jQuery.fn.shake = (intShakes, intDistance, intDuration) ->
  @each ->
    $(this).css 'position', 'relative'
    x = 1
    while x <= intShakes
      $(this).animate({ left: intDistance * -1 }, intDuration / intShakes / 4).animate({ left: intDistance }, intDuration / intShakes / 2).animate { left: 0 }, intDuration / intShakes / 4
      x++
    return
  this


$(document).ready ->

  window.refreshCaptchaImage = ->
    $('#captcha-image-resource').attr('src', $('#captcha-image-resource').data('src') + '?reset=' + Date.now())

  window.openVerifyCaptcha = ->

    $('#recaptcha-modal .modal-content.hidden').removeClass('hidden')

    mr.modals.closeActiveModal()
    mr.modals.showModal($('#recaptcha-modal'))

    window.refreshCaptchaImage()

    $("#Form_CaptchaForm").on 'submit', (e) ->
      $form = $(this)
      url = $form.attr('action')

      $.ajax({
                type: "POST"
                url: url
                data: $form.serialize()
                success: (data) ->
                  window.location.reload(false)
                error: ->
                  window.refreshCaptchaImage()
                  alert('Bitte nochmal versuchen')
            })

      e.preventDefault()
      false
